export default __webpack_public_path__ + "static/media/204.59dbc32d.gif";